module.exports = __webpack_public_path__ + "img/OT201.98c4f13.webp";